export const isEmptyObj = (data) => {
  return JSON.stringify(data) === "{}";
};

export const numFormat = (num) => {
  if (num === "" || num === null || num === undefined) {
    return "";
  }
  if (typeof num != "number" || num < 1000) {
    return "$" + num;
  } else {
    num = parseInt(num / 1000);
    //   num = num.toFixed(2)
    var c = num.toString().indexOf(".") !== -1 ? num.toLocaleString() : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    if (c > 1000) {
      c = c / 1000;
    }
    return "$" + c + "k";
  }
};

export const numFormat1 = (n) => {
  if (typeof n != "number") {
    return n;
  }
  if (n == 0 || !n) {
    return 0;
  }
  n = parseInt(n).toString();
  var re = /\d{1,3}(?=(\d{3})+$)/g;
  var n1 = n.replace(/^(\d+)((\.\d+)?)$/, function (s, s1, s2) {
    return s1.replace(re, "$&,") + s2;
  });
  return n1;
};

//是否对象
export const isObject = (obj) => {
  return obj !== null && typeof obj === "object";
};

//深度拷贝
export const deepCopy = (obj, cache = []) => {
  // just return if obj is immutable value
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  // if obj is hit, it is in circular structure
  const hit = find(cache, (c) => c.original === obj);
  if (hit) {
    return hit.copy;
  }

  const copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy,
  });

  Object.keys(obj).forEach((key) => {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy;
};

export const dateTime = {
  oneMin: 1000 * 60,
  oneHour: 1000 * 60 * 60,
  oneDay: 1000 * 60 * 60 * 24,
};

export const formatDate = (date, fmt = "yyyy-MM-dd") => {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  let o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + "";
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }
  return fmt;
};
export const copyUrl = function (url) {
  var Url2 = url;
  var oInput = document.createElement("input");
  oInput.value = Url2;
  document.body.appendChild(oInput);
  oInput.select(); // 选择对象
  document.execCommand("Copy"); // 执行浏览器复制命令
  oInput.className = "oInput";
  oInput.style.display = "none";
  this.$message({
    type: "success",
    message: this.$t("util.CopySuccess"),
  });
};
// 不保留2位
export const numFormat2 = function (num) {
  // 添加边界处理
  if (num === null || num === undefined || num === '') {
    return '';
  }
  // 转换为数字
  const number = parseFloat(num);
  if (isNaN(number)) {
    return num;
  }
  // 格式化逻辑
  let numStr = number.toString();
  if (number < 1000) {
    return numStr;
  } else {
    let temp = numStr.split(".");
    let temp1 = temp[0].replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    // 如果需要保留小数位，取消下面的注释
    // let temp2 = temp[1] !== undefined ? "." + temp[1] : "";
    // return temp1 + temp2;
    return temp1;
  }
};
// 保留2位
export const numFormatFix2 = function (num) {
  // 添加边界处理
  if (num === null || num === undefined || num === '') {
    return '';
  }
  // 转换为数字
  const number = parseFloat(num);
  if (isNaN(number)) {
    return num;
  }
  // 格式化逻辑
  let numStr = number.toString();
  if (number < 1000) {
    return numStr;
  } else {
    let temp = numStr.split(".");
    let temp1 = temp[0].replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    // 如果需要保留小数位，取消下面的注释
    let temp2 = temp[1] !== undefined ? "." + temp[1] : "";
    return temp1 + temp2;
  }
};
export const getduration = function (duration) {
  var totalSeconds = parseInt(duration / 1000);
  var modulo = totalSeconds % (60 * 60 * 24);
  //小时数
  var hours = Math.floor(modulo / (60 * 60));
  hours = hours < 10 ? "0" + hours : hours;
  modulo = modulo % (60 * 60);
  //分钟
  var minutes = Math.floor(modulo / 60);
  minutes = minutes < 10 ? "0" + minutes : minutes;
  //秒
  var seconds = modulo % 60;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  return `${padLeftZero(hours)}:${minutes}:${seconds}`;
};

const padLeftZero = (str) => {
  return ("00" + str).substr(str.length);
};

/* 表单验证 */
const reg = {
  qq: /^[1-9]\d{4,10}$/,
  tel: /^((13[0-9])|(15[^4])|(18[0-9])|(166)|(17[0-8])|(147)|(19[6,8,9]))\d{8}$|^(2[0-9]|3[0-9]|5[1-6,9]|6[0-9]|9[0-8]|8[0-8])\d{6}$/,
  user: /^[a-z]\w{5,15}$/i,
  pwd: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/,
  email: /^[1-9a-z]\w+@[0-9a-z\-]{2,}(\.[a-z]{2,}){1,2}$/i,
  valid: /^\d{6}$/,
  floatNum: /^[1-9][0-9]*\.?[0-9]{1,2}$/,
  integer: /^\d{0,11}$/,
};

export const regValid = (value) => {
  return reg["valid"].test(value);
};

export const regTel = (value) => {
  return reg["tel"].test(value);
};

export const regPwd = (value) => {
  return reg["pwd"].test(value);
};

export const regFloat = (value) => {
  return reg["floatNum"].test(value);
};

export const regNum = (value) => {
  return reg["integer"].test(value);
};

// 时间选择
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (("" + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}

/* 权限 */
export const hasPowerToDo = (name) => {
  //create 创建   update 修改   delete 删除
  const userPosition = localStorage.getItem("userPosition");
  const position = {
    /*============ 意向客户 ==========*/
    createPotential: {
      //创建
      经销商: false,
      店员: true,
      导购员: true,
      店长: true,
    },

    updatePotential: {
      //修改
      经销商: false,
      店员: true,
      导购员: true,
      店长: true,
    },

    signPotential: {
      //标记
      经销商: false,
      店员: true,
      导购员: true,
      店长: true,
    },
    createPotentialCustomer: {
      //创建体验单
      经销商: false,
      店员: true,
      导购员: true,
      店长: true,
    },
    orderToPotential: {
      //指派
      经销商: false,
      店员: false,
      导购员: false,
      店长: true,
    },
    newOrder: {
      //新增订单
      经销商: false,
      店员: true,
      导购员: true,
      店长: true,
    },

    /*============= 工单 =============*/
    createMeasure: {
      //创建
      经销商: false,
      店员: true,
      导购员: true,
      店长: true,
    },
    updateMeasure: {
      //修改
      经销商: false,
      店员: true,
      导购员: true,
      店长: true,
    },
    cancelMeasure: {
      //销单
      经销商: false,
      店员: true,
      导购员: true,
      店长: true,
    },

    /*============= 集团促销活动 =============*/
    saveGroup: {
      //保存
      经销商: true,
      店员: false,
      导购员: false,
      店长: false,
    },

    /*============= 区域 活动 =============*/
    updateArea: {
      //修改活动目标
      经销商: true,
      店员: false,
      导购员: false,
      店长: false,
    },

    completeArea: {
      // 完成情况
      经销商: false,
      店员: true,
      导购员: false,
      店长: true,
    },

    updateTodayAim: {
      //修改今日完成量
      经销商: false,
      店员: false,
      导购员: false,
      店长: true,
    },

    /*============= 经销商促销活动 =============*/
    createDealer: {
      //创建
      经销商: true,
      店员: false,
      导购员: false,
      店长: false,
    },
    updateDealer: {
      //修改
      经销商: true,
      店员: false,
      导购员: false,
      店长: false,
    },
    deleteDealer: {
      //删除
      经销商: true,
      店员: false,
      导购员: false,
      店长: false,
    },
    submitDealer: {
      //提交审批
      经销商: true,
      店员: false,
      导购员: false,
      店长: false,
    },

    /*============= 客户订单 =============*/
    updateCustomer: {
      //修改
      经销商: false,
      店员: false,
      导购员: false,
      店长: true,
    },

    /*============= 短信模板 =============*/
    createMessage: {
      //创建
      经销商: true,
      店员: false,
      导购员: false,
      店长: false,
    },
    updateMessage: {
      //修改
      经销商: true,
      店员: false,
      导购员: false,
      店长: false,
    },
    deleteMessage: {
      //删除
      经销商: true,
      店员: false,
      导购员: false,
      店长: false,
    },

    /*============= 我的 =============*/
    resetPwd: {
      //创建
      经销商: false,
      店员: true,
      导购员: true,
      店长: true,
    },
  };

  return position[name][userPosition] || false;
};

// 保留小数位
export const numberFormat = (val,number=2) => {
  if (val!==null && val!== undefined && val!==0) {
    return (+val).toFixed(number)
  }
  return val
}
